import { twMerge } from 'tailwind-merge';

import type { Match } from '@/types/api';
import type { DodgeballMatch } from '@/types/sports/dodgeball';

export const DodgeballPreview = ({ match }: { match: Match }) => {
  const {
    away_team,
    home_team,
    state: { scores },
  } = match as DodgeballMatch;

  return (
    <div>
      <div className="flex items-center justify-between space-x-2 text-6xl">
        <div>{scores.home_team}</div>
        <div>{scores.away_team}</div>
      </div>

      <div className="mt-4 flex items-center justify-between space-x-2">
        <div className="flex items-center gap-4 text-2xl font-bold uppercase">
          {home_team.team_image_url ? (
            <img
              className="size-12"
              src={home_team.team_image_url}
              alt={home_team.name}
            />
          ) : (
            <span
              className={twMerge(
                'fi mr-2',
                home_team.country_code && `fi-${home_team.country_code}`,
              )}
            />
          )}
          {home_team.scoreboard_name}
        </div>
        <div>vs</div>
        <div className="flex items-center gap-4 text-2xl font-bold uppercase">
          {away_team.scoreboard_name}
          {away_team.team_image_url ? (
            <img
              className="size-12"
              src={away_team.team_image_url}
              alt={away_team.name}
            />
          ) : (
            <span
              className={twMerge(
                'fi',
                away_team.country_code && `fi-${away_team.country_code}`,
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
};
